<template>
    <div class="description" >
        <div>
          <em>Indicaciones:</em>

            <p>Intenta adivinar quien se encuentra en la tarjeta oculta de la parte superior,
              Seleccionando uno de los tres personajes que se encuentran en la parte inferior.
            </p>
            
        </div>
    </div>
</template>

<style scoped>
.description {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Merriweather', serif;
  height:5em;
    background: rgb(154, 221, 212);
  background: linear-gradient(
    90deg,
    rgb(154, 221, 212, 1) 0%,
    rgba(171, 214, 227, 1) 50%,
    rgba(171, 214, 227, 1) 100%
  );
}
</style>